import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import './PrivacyModal.css';

const PrivacyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="modal-backdrop" onClick={onClose}>
        <motion.div 
          className="modal-content pdpa-modal"
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="modal-close-btn" onClick={onClose}><X size={20}/></button>
          <h2 className="pdpa-title">นโยบายความเป็นส่วนตัว (Privacy Policy)</h2>
          <div className="pdpa-text-content">
            <p><strong>ข้อตกลงและเงื่อนไขการเก็บข้อมูลส่วนบุคคล</strong></p>
            <p>เพื่อความโปร่งใสและเพื่ออำนวยความสะดวกในการให้บริการระบบสมาชิกและการจัดส่งอาหาร (ปิ่นโต) ทางร้าน Clean Food CR มีความจำเป็นต้องเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลของท่าน ได้แก่:</p>
            <ul className="pdpa-list">
              <li><strong>เบอร์โทรศัพท์และชื่อ-นามสกุล:</strong> เพื่อใช้ในการยืนยันตัวตน เข้าสู่ระบบ และติดต่อประสานงาน</li>
              <li><strong>ข้อมูลสุขภาพและการแพ้อาหาร:</strong> เพื่อจัดเตรียมอาหารให้สอดคล้องกับเป้าหมายสุขภาพ และความปลอดภัยสูงสุดของท่าน</li>
              <li><strong>ที่อยู่สำหรับจัดส่ง:</strong> เพื่ออำนวยความสะดวกในการจัดส่งอาหารให้ถึงมือท่านอย่างถูกต้องแม่นยำ</li>
            </ul>
            <p><strong>การปกป้องและรักษาข้อมูล:</strong><br/>ข้อมูลทั้งหมดของท่านจะถูกเก็บรักษาไว้ในระบบอย่างปลอดภัยตามมาตรฐาน และจะถูกใช้งานเพื่อวัตถุประสงค์ในการให้บริการของทางร้านเท่านั้น จะไม่มีการนำไปจำหน่าย แลกเปลี่ยน หรือเปิดเผยให้แก่บุคคลที่สามโดยเด็ดขาด หากไม่ได้รับความยินยอมจากท่าน</p>
            <p className="pdpa-note"><em>*โดยการทำเครื่องหมายยินยอม ถือว่าท่านได้รับทราบและตกลงให้ร้านประมวลผลข้อมูลตามวัตถุประสงค์ที่ได้ชี้แจงไว้ข้างต้น</em></p>
          </div>
          <div className="modal-actions-footer">
            <button className="btn btn-primary pdpa-accept-btn" onClick={onClose}>รับทราบและปิดหน้าต่าง</button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default PrivacyModal;
